import { ResponsibilityType,CheckListProcessType } from '../service-proxies';


export class CheckListDto implements ICheckListDto {
    id!: number;
    checkListName!: string | undefined;
    responsibilityType!: ResponsibilityType;
    checkListProcessType!: CheckListProcessType;
    responsibilityTypeName!: string | undefined;
    checkListProcessTypeName!: string | undefined;
    isActive!: boolean;

    constructor(data?: ICheckListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.checkListName = _data["checkListName"];
            this.responsibilityType = _data["responsibilityType"];
            this.checkListProcessType = _data["checkListProcessType"];
            this.responsibilityTypeName = _data["responsibilityTypeName"];
            this.checkListProcessTypeName = _data["checkListProcessTypeName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CheckListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["checkListName"] = this.checkListName;
        data["responsibilityType"] = this.responsibilityType;
        data["checkListProcessType"] = this.checkListProcessType;
        data["responsibilityTypeName"] = this.responsibilityTypeName;
        data["checkListProcessTypeName"] = this.checkListProcessTypeName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICheckListDto {
    id: number;
    checkListName: string | undefined;
    responsibilityType: ResponsibilityType;
    checkListProcessType: CheckListProcessType;
    responsibilityTypeName: string | undefined;
    checkListProcessTypeName: string | undefined;
    isActive: boolean;
}

